import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../components/common/PageLayout';
import './B2C.css';

const PROGRAMS = [
  {
    id: 'sfdc-devops',
    title: 'Master Salesforce DevOps with Copado and Agentia',
    to: '/course/salesforce-devops-copado-agentia?date=22nd%20June%202026&time=8AM-9AM%20IST',
    level: 'Intermediate to Advanced',
    duration: '2 Weeks',
    description:
      'Learn how to accelerate Salesforce releases using Copado and Agentia with CI/CD pipelines and AI-driven release planning.',
  },
  {
    id: 'sfdc-dev',
    title: 'Salesforce AI Developer',
    to: '/course/salesforce-ai-developer?date=1st%20June%202026&time=10AM-12PM%20IST',
    level: 'Beginner to Advanced',
    duration: '24 weeks',
    description:
      'Go deeper into Apex, integrations, AI , Agentforce and Lightning Web Components to build scalable Salesforce solutions.',
  },
  {
    id: 'full-stack',
    title: 'Full Stack Web Development',
    to: '/course/full-stack-web-development',
    level: 'Beginner to Advanced',
    duration: '24 weeks',
    description:
      'Learn front-end and back-end skills to build production-ready web applications end to end.',
  },
  {
    id: 'web-dev',
    title: 'Web Development',
    to: '/course/web-development',
    level: 'Beginner · Front-end',
    duration: '10 weeks',
    description:
      'Cover modern HTML, CSS, and JavaScript essentials to design and build responsive websites.',
  },
];

const B2C = () => (
  <PageLayout>
    <section className="page-hero">
      <h1>For Individuals</h1>
      <p>Learn in-demand skills at your own pace with courses and projects designed for career growth.</p>
    </section>

    <section className="b2c-programs" aria-labelledby="b2c-programs-title">
      <div className="b2c-programs-inner">
        <header className="b2c-programs-header">
          <p className="b2c-programs-kicker">For Individuals</p>
          <h2 id="b2c-programs-title" className="b2c-programs-title">
            Programs You Can Enroll In
          </h2>
          <p className="b2c-programs-subtitle">
            Pick a focused learning path and move at your own pace. Each program blends concepts, labs, and real-world projects to
            help you ship work that hiring managers care about.
          </p>
        </header>
        <div className="b2c-programs-grid">
          {PROGRAMS.map((program) => (
            <Link key={program.id} to={program.to} className="b2c-program-card">
              <div className="b2c-program-pill" aria-hidden="true" />
              <div className="b2c-program-meta">
                <span className="b2c-program-level">{program.level}</span>
                <span className="b2c-program-duration">{program.duration}</span>
              </div>
              <h3 className="b2c-program-title">{program.title}</h3>
              <p className="b2c-program-text">{program.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  </PageLayout>
);

export default B2C;
